const getters = {
  headerShow: state => state.app.headerShow,
  defaultImg: state => state.app.defaultImg,
  defaultHeadImg: state => state.app.defaultHeadImg
}
export default getters
